(function () {
    'use strict';
    angular.module('Services').service('AdminTeamActionTableService', AdminTeamActionTableService);
    AdminTeamActionTableService.$inject = [
        'TableLiteFactory',
        'AdminPermissionService',
        '$location'
    ];

    function AdminTeamActionTableService(
        TableLiteFactory,
        AdminPermissionService,
        $location
    ) {
        return function(){
           
            let items =[]
            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    viewName: 'staff',
                    label: 'Staff Member',
                    filterName:'firstName',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        class: 'table-input',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                    },
                    
                    headerFn: function () {
                        sort(this.filterName)
                    }
                },{
                    viewName: 'email',
                    label: 'Email',
                    filterName:'email',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        class: 'table-input',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    viewName: 'active',
                    label: 'Status',
                    filterName:'active',
                    width: '135px',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        items:['Active','InActive'],
                        onSubmit: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    },
                },{
                    viewName: 'permissionGroup',
                    label: 'Permission',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    viewName: 'customer',
                    label: 'Customer',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        class: 'table-input',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                        
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    viewName: 'actions',
                    label: 'Actions',
                    filter:{
                        type:'button'
                    }
                }
                ],
                data: [],
                
            };

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AdminPermissionService.AdminCurrentUser.getAdminCurrentUserList,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            let activeFilters = tableActions.activeFilters;

            
           
            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                        item.staff = item.user.firstName +' '+ item.user.lastName;
                        item.email = item.user.email;
                        item.active=item.user.active ? 'Active':'InActive';
                        item.permissionGroup = item.user.permissionGroup.name;
                        item.customer = [item.auditUser ? item.auditUser.email:'N/A'];
                        
                        item.actions = {
                                type: 'button',
                                buttons:[{
                                    text: 'View',
                                    action:  function () {
                                        $location.path('/administration/team-actions/'+item.user.id); //: change detailsId to id
                                    },
                                class: 'btn-info btn-quirk btn-sm'
                                }]
                            };
                    tableData.data.push(item);
                });
            };

            this.tableData = tableData;
        }

        const refresh = tableActions.sendRequest()
        
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/administrationTable/AdminTeamActionTableService.js